/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @author Vladislav Urbánek <urbanek.vlada@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

/**
 * Typ média video stream.
 * Používá se pouze URL ze serveru bez podpory offline stavu.
 * @implements {ViewerType}
 */
class StreamViewerType {
  /**
   * Vytvoří instanci.
   * @param {ViewerControllerVideoFactory|WebosSignage3_0StreamViewerControllerFactory} controllerFactory
   * @param {ViewerSourceCreator} sourceCreator
   */
  constructor(controllerFactory, sourceCreator) {
    // TODO Lepší organizace Viewer modulu.
    // - Zde by se hodilo mít inteface VideoViewerControllerFactory.
    // - Zatím řešeno jako výčet typů a zde se spoléhá na stejné parametry u create,
    //   což není úplně vhodné.
    // - Také by měl existovat VideoViewerSourceCreator a ne jen obecné rozhraní.
    this.controllerFactory = controllerFactory;
    this.sourceCreator = sourceCreator;
  }

  /** @inheritdoc */
  createController() {
    return this.controllerFactory.create();
  }

  /** @inheritdoc */
  getCheckFile(medium) {
    // Streamy nemají v detailu média nastavení "Kontrolovat aktuální verzi".
    return false;
  }

  /** @inheritdoc */
  getSourceCreator() {
    return this.sourceCreator;
  }

  /** @inheritdoc */
  getUrl(medium) {
    return new Promise((resolve) => resolve(medium.url ?? undefined));
  }

  /** @inheritdoc */
  isExtractable() {
    return false;
  }

  /** @inheritdoc */
  isOfflineable() {
    return false;
  }

  /** @inheritdoc */
  isPreloadable(medium) {
    return true;
  }
}

export default StreamViewerType;
